<app-chart [title]="title" [tooltip]="tooltip" [headerExtraContent]="headerExtraContent">
  <p-table class="chart-table" [value]="rows" pSticky>
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngTemplateOutlet="headersTemplate"></ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <ng-container [ngTemplateOutlet]="rowTemplate" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
      </tr>
    </ng-template>
  </p-table>
</app-chart>
